/**
 * LLM Service — delegates to the backend proxy at POST /api/analysis/property.
 *
 * API keys are held server-side only. The frontend never touches provider keys.
 * Requires a valid JWT (user must be logged in).
 */

const API_BASE = import.meta.env.VITE_API_URL || '';

/** True when the user is authenticated (token present). The backend validates it. */
export const llmConfigured = true;

/**
 * Analyze auction property risk — used in AIAnalysisModal.
 * Returns structured JSON with riskScore, riskLevel, riskFactors, matriculaItems, recommendation.
 */
export async function analyzePropertyRisk(property) {
  const p = property;

  const res = await fetch(`${API_BASE}/api/analysis/property`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
    },
    body: JSON.stringify({
      titulo: p.titulo,
      banco: p.banco,
      modalidade: p.modalidade,
      condicao: p.condicao,
      valorAvaliacao: p.valorAvaliacao,
      valorMinimo: p.valorMinimo,
      desconto: p.desconto,
      endereco: p.endereco,
      cidade: p.cidade,
      estado: p.estado,
      matricula: p.matricula,
      status: p.status,
    }),
    signal: AbortSignal.timeout(60_000),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `analysis_failed:${res.status}`);
  }

  const data = await res.json();
  return {
    riskScore: typeof data.riskScore === 'number' ? Math.max(0, Math.min(100, data.riskScore)) : 50,
    riskLevel: ['baixo', 'moderado', 'elevado'].includes(data.riskLevel) ? data.riskLevel : 'moderado',
    riskFactors: Array.isArray(data.riskFactors) ? data.riskFactors.slice(0, 5) : [],
    locationAdvantages: Array.isArray(data.locationAdvantages) ? data.locationAdvantages.slice(0, 4) : [],
    matriculaItems: Array.isArray(data.matriculaItems)
      ? data.matriculaItems.map((i) => ({ name: String(i.name || ''), ok: Boolean(i.ok), detail: String(i.detail || '') }))
      : [],
    recommendation: String(data.recommendation || 'Consulte um advogado especializado.'),
  };
}

function getAuthHeader() {
  try {
    const token = localStorage.getItem('accessToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
